import e from "./design-system.es25.js";
const i = {
  name: "DsMediaQuery",
  props: {
    /**
     * Named breakpoint to match on.
     */
    breakpoint: String,
    /**
     * Whether or not to exactly match the breakpoint.  This should be used in conjunction with the `breakpoint` prop.
     */
    exact: Boolean,
    /**
     * Minimum width of the breakpoint.
     */
    width: {
      type: Number,
      default: 0
    },
    /**
     * Custom media query string.
     */
    query: String
  },
  setup(t) {
    return { isMatch: e({
      breakpoint: t.breakpoint,
      exact: t.exact,
      width: t.width,
      query: t.query
    }) };
  },
  render() {
    const { isMatch: t } = this;
    return this.$slots.default({
      isMatch: t
    });
  }
};
export {
  i as default
};
//# sourceMappingURL=design-system.es22.js.map
